
import XTable from 'vux/src/components/x-table/index.vue'

import { mapMutations } from 'vuex'
export default {
name: 'DermatomeMap',
components: {
XTable,
},
created() {
this.hideLoad()
},
methods: {
...mapMutations(['hideLoad']),
},
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/Chart_DermatomeMap.vue